export const debuggingEnabled =
    process.env.NODE_ENV !== 'production' || process.env.REACT_APP_STAGING;

export const features = {
    debug: process.env.REACT_APP_DEBUG,
};
